// src/components/ui/label.jsx
import React from 'react';

export const Label = ({ 
  htmlFor, 
  children, 
  className = '',
  required = false 
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`block text-sm font-medium text-foreground mb-1 ${className}`}
    >
      {children}
      {required && <span className="text-destructive ml-1">*</span>}
    </label>
  );
};

export default Label;